import Devices from "../Devices/Devices"

const AwayDevices = () => (
  <Devices
    preset={{ status: "Away" }}
    locked={["status"]}
    title="Away devices"
  />
)

export default AwayDevices
